import AppSidebar from "./AppSidebar";
import { ConfigProvider, Layout, theme } from "antd";
import AppHeader from "./AppHeader";
import './index.scss';
import AppPage from "./AppPage";
import { configDark, configLight } from "../constants/theme";
import { useSelector } from "react-redux";
import { Routes, Route, useLocation } from 'react-router-dom';
import Login from "../page/auth/Login";
import AuthRoutes from "../page/auth/AuthRoutes";
import utc from 'dayjs/plugin/utc';
import dayjs from "dayjs";
import ruRU from "antd/es/locale/ru_RU";

dayjs.extend(utc);
dayjs.locale('ru');

const AppLayout = () => {
    const { systemMode } = useSelector((state) => state.theme);
    const { data: { isAuthenticated } } = useSelector((state) => state.auth);
    const location = useLocation();

    const { defaultAlgorithm, darkAlgorithm } = theme;

    const hideSidebar = location.pathname.includes('/test');

    return (
        <ConfigProvider
            locale={ruRU}
            theme={{
                algorithm: systemMode === 'dark' ? darkAlgorithm : defaultAlgorithm,
                token: systemMode === 'dark' ? configDark : configLight,
            }}
        >
            <AuthRoutes>
                {!isAuthenticated ? (
                    <Routes>
                        <Route path="/login" element={<Login />} />
                    </Routes>
                ) : (
                    <Layout>
                        <AppHeader />
                        <Layout>
                            {!hideSidebar && <AppSidebar />}
                            <Layout className={'ant--page'}>
                                <AppPage />
                            </Layout>
                        </Layout>
                    </Layout>
                )}
            </AuthRoutes>
        </ConfigProvider>
    );
};

export default AppLayout;